import { createApp } from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import sanity from '@/sanity';
import '@/assets/styles/index.css';
import ImageWrap from '@/components/ImageWrap.vue';
import FixedLoader from '@/components/FixedLoader.vue';
import { BlockContent } from '@/sanity/blocks';

const app = createApp(App);

app.use(router);
app.use(store);
app.use(sanity);

app.component('BlockContent', BlockContent);
app.component('FixedLoader', FixedLoader);
app.component('ImageWrap', ImageWrap);

app.mount('#app');

router.afterEach((to) => {
  if (to.name !== 'home') store.commit.setNavLight(false);
  store.commit.setNavActive(false);
  document.body.style.overflow = '';
  store.commit.setBackgroundWhite(false);
});
